module.exports = __webpack_public_path__ + "img/lavista-small.a0d18199.svg";